<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">{{data.id ? 'Edit' : 'New'}} Pass On Log</h4>
                </div>
                <div class="modal-body">
                    <!-- ___ Building ___ -->
                    <div class="row m-b-sm" [hidden]="passOnLogService.buildingsForUpdate.length < 2">
                        <div class="col-md-4">
                            <label>Building</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            <select class="form-control" name="buildingId" [ngModel]="data.buildingId"
                                    required #buildingSelect>
                                <option value="" hidden></option>
                                <option *ngFor="let build of passOnLogService.buildingsForUpdate" [value]="build.id">
                                    {{build.name}}
                                </option>
                            </select>
                        </div>
                    </div>

                    <!-- ___ Subject ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Subject</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            <input class="form-control" name="subject" [ngModel]="data.subject" required>
                        </div>
                    </div>

                    <!-- ___ Announcement  ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Announcement</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            <textarea class="form-control"
                                      name="announcement"
                                      [ngModel]="data.announcement"
                                      maxlength="1024"
                                      required>
                            </textarea>
                        </div>
                    </div>

                    <!-- ___ Start Date ___ -->
                    <div class="row m-b-sm long-date-field">
                        <div class="col-md-4">
                            <label>Start Date</label>
                        </div>
                        <mat-form-field class="col-md-8" style="margin-right: 0px;">
                            <input matInput
                                   [(ngModel)]="startDate"
                                   name="startDate"
                                   [matDatepicker]="startPicker"
                                   (focus)="startPicker.open()"
                                   (click)="startPicker.open()"
                                   (ngModelChange)="onStartDateChange()"
                                   placeholder="Choose a date" required>
                            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                            <mat-datepicker #startPicker></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <!-- ___ End Date ___ -->
                    <div class="row m-b-sm long-date-field">
                        <div class="col-md-4">
                            <label>End Date</label>
                        </div>
                        <mat-form-field class="col-md-8" style="margin-right: 0px;">
                            <input matInput
                                   [(ngModel)]="endDate"
                                   [min]="startDate"
                                   name="endDate"
                                   (focus)="endPicker.open()"
                                   (click)="endPicker.open()"
                                   [matDatepicker]="endPicker"
                                   placeholder="Choose a date" required>
                            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                            <mat-datepicker #endPicker></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <div class="row text-center space-30">
                        <button type="submit" class="btn btn-primary submit-btn" [disabled]="disabledSubmit">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/pass-on-log/pass-on-log-modal/pass-on-log-modal.component.html